import React, { useEffect, useState } from "react";
import { Accordion } from "./Accordion";

interface ChipGridAccordionProps<T> {
  title: string;
  totalCount: number;
  items: T[];
  isFiltering?: boolean;
  itemKey: (item: T) => string;
  itemLabel: (item: T) => string;
  itemHref: (item: T) => string;
}

export function ChipGridAccordion<T>({ title, totalCount, items, isFiltering, itemKey, itemLabel, itemHref }: ChipGridAccordionProps<T>) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(!!isFiltering);
  }, [isFiltering]);

  if (items.length === 0) return null;

  return (
    <Accordion title={title} count={items.length === totalCount ? totalCount : `${items.length} / ${totalCount}`} isOpen={isOpen} onToggle={() => setIsOpen((prev) => !prev)}>
      <div className="dt-chip-grid">
        {items.map((item) => (
          <a key={itemKey(item)} className="dt-chip" href={itemHref(item)}>{itemLabel(item)}</a>
        ))}
      </div>
    </Accordion>
  );
}
